import { Deserializable } from '@models/deserializable';
import { custom, deserialize, serializable } from 'serializr';
import { ResultConstant } from '@enums/result-constant.enum';

export class CurrentExecutingStepModel implements Deserializable {
  @serializable
  public stepId: number;

  @serializable
  public result: ResultConstant;

  @serializable(
    custom(
      (v) => {
        return v;
      },
      (v) => {
        if (!v || v.length == 0) return [];
        else return v;
      },
    ),
  )
  public stepResultIds: string[];

  public testCaseResultId: number;

  deserialize(input: any): this {
    return Object.assign(this, deserialize(CurrentExecutingStepModel, input));
  }
}
